import { render } from "./UntradingAppV2.vue?vue&type=template&id=141010b1"
import script from "./UntradingAppV2.vue?vue&type=script&lang=js"
export * from "./UntradingAppV2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__